import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import CookieBanner from '../../components/feature/CookieBanner';

export default function Contact() {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxImage, setLightboxImage] = useState('');

  const openLightbox = (imageSrc: string) => {
    setLightboxImage(imageSrc);
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    setLightboxImage('');
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />

      <main className="pt-24 md:pt-32 pb-12 md:pb-20">
        <div className="max-w-[1400px] mx-auto px-6">
          <header className="mb-16 text-center">
            <h1 className="text-5xl font-bold text-primary mb-4">İletişim</h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Bursa Tente ile iletişime geçin, projeleriniz için ücretsiz keşif ve teklif alın
            </p>
          </header>

          <div className="grid lg:grid-cols-2 gap-12 mb-16">
            {/* Contact Info */}
            <div className="space-y-8">
              <section>
                <h2 className="text-3xl font-bold text-primary mb-6">İletişim Bilgileri</h2>
                <div className="space-y-6">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-secondary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-phone-fill text-2xl text-secondary"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-primary mb-1">Telefon</h3>
                      <a
                        href="tel:+905421821925"
                        className="text-gray-700 hover:text-secondary transition-colors cursor-pointer"
                      >
                        +90 542 182 19 25
                      </a>
                      <p className="text-sm text-gray-500 mt-1">Pazartesi - Cumartesi: 09:00 - 18:00</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-secondary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-map-pin-fill text-2xl text-secondary"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-primary mb-1">Adres</h3>
                      <p className="text-gray-700">Altıparmak Mahallesi, Haşim İşcan Caddesi No:24</p>
                      <p className="text-gray-700">Osmangazi / Bursa, Türkiye</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-secondary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-global-line text-2xl text-secondary"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-primary mb-1">Web</h3>
                      <a
                        href="https://bursatente.com.tr"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-gray-700 hover:text-secondary transition-colors cursor-pointer"
                      >
                        bursatente.com.tr
                      </a>
                    </div>
                  </div>
                </div>
              </section>

              <section className="bg-primary text-white rounded-2xl p-8">
                <h3 className="text-2xl font-bold mb-4">Hızlı İletişim</h3>
                <p className="text-gray-200 mb-6">
                  WhatsApp üzerinden 7/24 mesaj bırakabilir, hızlı yanıt alabilirsiniz
                </p>
                <a
                  href="https://wa.me/905421821925?text=Merhaba,%20tente%20hakkında%20bilgi%20almak%20istiyorum"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full bg-white text-primary text-center px-6 py-3 rounded-full font-bold hover:bg-gray-100 transition-all mb-3 cursor-pointer"
                >
                  <i className="ri-whatsapp-fill mr-2"></i>
                  WhatsApp ile Mesaj Gönder
                </a>
                <a
                  href="tel:+905421821925"
                  className="block w-full border-2 border-white text-white text-center px-6 py-3 rounded-full font-bold hover:bg-white hover:text-primary transition-all cursor-pointer"
                >
                  <i className="ri-phone-fill mr-2"></i>
                  Hemen Ara
                </a>
              </section>
            </div>

            {/* Map */}
            <div>
              <h2 className="text-3xl font-bold text-primary mb-6">Konum</h2>
              <div className="rounded-2xl overflow-hidden shadow-lg h-[500px]">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3048.9876543210123!2d29.0123456789!3d40.1987654321!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDDCsDExJzU1LjYiTiAyOcKwMDAnNDQuNCJF!5e0!3m2!1str!2str!4v1234567890123"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Bursa Tente Konum - Altıparmak Mahallesi, Haşim İşcan Caddesi No:24"
                ></iframe>
              </div>
            </div>
          </div>

          <section className="grid lg:grid-cols-2 gap-8 md:gap-12 mb-12 md:mb-20">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-primary mb-6">Bize Ulaşın</h2>
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-2xl text-primary"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-primary mb-2">Adres</h3>
                    <p className="text-gray-600">
                      Altıparmak Mahallesi, Haşim İşcan Caddesi No:24<br />
                      Osmangazi / Bursa
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-2xl text-primary"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-primary mb-2">Telefon</h3>
                    <a
                      href="tel:+905421821925"
                      className="text-gray-600 hover:text-secondary transition-colors cursor-pointer"
                    >
                      +90 542 182 19 25
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-whatsapp-line text-2xl text-primary"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-primary mb-2">WhatsApp</h3>
                    <a
                      href="https://wa.me/905421821925?text=Merhaba,%20tente%20ve%20pergola%20sistemleri%20hakkında%20bilgi%20almak%20istiyorum"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-gray-600 hover:text-secondary transition-colors cursor-pointer"
                    >
                      +90 542 182 19 25
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-time-line text-2xl text-primary"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-primary mb-2">Çalışma Saatleri</h3>
                    <p className="text-gray-600">
                      Pazartesi - Cumartesi: 09:00 - 18:00<br />
                      Pazar: Kapalı
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="bg-gray-50 rounded-2xl p-12">
            <h2 className="text-3xl font-bold text-primary mb-6 text-center">Sıkça Sorulan Sorular</h2>
            <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">
              {[
                {
                  question: 'Ücretsiz keşif yapıyor musunuz?',
                  answer: 'Evet, Bursa genelinde ücretsiz keşif ve ölçüm hizmeti sunuyoruz.',
                },
                {
                  question: 'Montaj süresi ne kadar?',
                  answer: 'Ortalama montaj süresi 1-2 gündür, proje büyüklüğüne göre değişiklik gösterebilir.',
                },
                {
                  question: 'Garanti süresi ne kadar?',
                  answer: 'Tüm ürünlerimizde 2 yıl garanti, işçilikte 5 yıl garanti sunuyoruz.',
                },
                {
                  question: 'Hangi ödeme yöntemlerini kabul ediyorsunuz?',
                  answer: 'Nakit, havale/EFT ve kredi kartı ile ödeme kabul ediyoruz.',
                },
              ].map((faq, index) => (
                <div key={index} className="bg-white rounded-xl p-6">
                  <h3 className="font-bold text-primary mb-2">{faq.question}</h3>
                  <p className="text-gray-600 text-sm">{faq.answer}</p>
                </div>
              ))}
            </div>
          </section>
        </div>
      </main>

      <Footer />
      <CookieBanner />

      {/* Lightbox Modal */}
      {lightboxOpen && (
        <div
          className="fixed inset-0 bg-black/95 z-[100] flex items-center justify-center p-4 cursor-pointer"
          onClick={closeLightbox}
        >
          <button
            className="absolute top-4 right-4 w-12 h-12 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center text-white text-2xl transition-colors"
            onClick={closeLightbox}
            aria-label="Kapat"
          >
            <i className="ri-close-line"></i>
          </button>
          <img
            src={lightboxImage}
            alt="Büyütülmüş görsel"
            className="max-w-full max-h-full object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
}
